import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"pa-5":""}},[_c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":"","pt-3":""}},[_c('h1',[_vm._v("Ontologia: sipam")])]),_c(VFlex,{attrs:{"xs12":"","pt-3":""}},[_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-default-footer":true,"items-per-page":-1},scopedSlots:_vm._u([{key:"item.uri",fn:function({ item }){return [_c('span',{ref:item.label,domProps:{"innerHTML":_vm._s(item.uri)}})]}}])})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }